// Duplicated from ab-common
import { useContext } from 'react';
import InitialPropsContext from "../components/InitialPropsContext";
export var useInitialProps = function useInitialProps() {
  return useContext(InitialPropsContext) || {};
};
export default useInitialProps;